import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { UserType } from '~types/api/user';
import { api, timing, error } from '~Utils/debugLogger';

export const useGetUserType = (user_id?: string) => {
  return useQuery<unknown, Error, UserType>(
    ['userType', user_id],
    async () => {
    api('Starting getUserType API call');
    const apiStartTime = Date.now();

    if (!user_id) {
      api('getUserType: No user_id provided');
      return;
    }

    api('getUserType: Getting auth token');
    const tokenStart = Date.now();
    const token = useUserStore.getState().token;
    timing('getUserType: Auth token obtained', tokenStart);

    api('getUserType: Making API request');
    const requestStart = Date.now();
    const response = await fetch(`${BASE_API_URL}accounts/${user_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (!response.ok) {
      error(`getUserType: Request failed with status ${response.status}`);
      throw new Error('Failed to get user type');
    }

    timing('getUserType: Request completed', requestStart);
    const data = await response.json();
    timing('getUserType: Total time', apiStartTime);

    return data;
  }, {
    enabled: !!user_id, // Only run query if user_id is provided
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
};
